// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/Content/Content/Charge/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Charges_Content_Content_Charge($location_ids: [uuid!]!) {
  vaxiom_sys_organizations(where: { _id: { _in: $location_ids } }) {
    id
  }
}

`